module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('h2', [_vm._v("1.默认样式")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('v-scrollbar', {
    staticClass: "vScrollbar1",
    on: {
      "scroll": _vm.scrollFn
    }
  }, _vm._l((30), function(n) {
    return _c('h1', [_vm._v("default")])
  })), _c('h2', [_vm._v("2.不滚动时隐藏滚动条")]), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('v-scrollbar', {
    staticClass: "vScrollbar2",
    attrs: {
      "isHideBar": true
    }
  }, _vm._l((30), function(n) {
    return _c('h3', [_vm._v(":isHideBar=\"true\"")])
  })), _c('h2', [_vm._v("3.顶部滚动条")]), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('v-scrollbar', {
    staticClass: "vScrollbar3",
    attrs: {
      "isTopBar": true
    }
  }, _vm._l((30), function(n) {
    return _c('h3', [_vm._v(":isTopBar=\"true\"")])
  })), _c('h2', [_vm._v("4.通过slot自定义复杂滚动条样式")]), _vm._v(" "), _vm._m(3), _vm._v(" "), _c('v-scrollbar', {
    staticClass: "vScrollbar4",
    attrs: {
      "barContainerStyle": {
        width: '14px',
        background: '#282828',
        borderLeft: '1px solid #1d1d1d',
        borderRight: '1px solid #3e3e3b'
      },
      "barStyle": {
        width: '8px',
        border: '1px solid #191919',
        borderRadius: '5px',
        overflow: 'hidden'
      }
    }
  }, [_c('div', {
    style: ({
      width: '100%',
      height: '100%',
      background: '#454545',
      borderLeft: '1px solid #585858'
    }),
    slot: "barIn"
  }), _vm._l((30), function(n) {
    return _c('h3', [_vm._v(":isTopBar=\"true\"")])
  })], 2), _c('h2', [_vm._v("5.顶部滚动条上一个音乐的符号")]), _vm._v(" "), _vm._m(4), _vm._v(" "), _c('v-scrollbar', {
    staticClass: "vScrollbar5",
    attrs: {
      "isTopBar": true
    }
  }, [_vm._l((30), function(n) {
    return _c('h3', [_vm._v(":isTopBar=\"true\"")])
  }), _c('div', {
    style: ({
      position: 'absolute',
      right: '0',
      top: '-5px',
      color: '#17ce28',
      zIndex: '1000'
    }),
    slot: "topBarIn"
  }, [_vm._v("♪")])], 2), _c('h2', [_vm._v("6.当滚动内容高度动态变化时，执行重新计算")]), _vm._v(" "), _c('h3', [_vm._v("html")]), _vm._v(" "), _c('pre', [_c('code', {
    staticClass: "highlight-js"
  }, [_vm._v("  <v-scrollbar  ref=\"vScrollbar6\" class=\"vScrollbar6\">\n    <h1 v-for=\"v in testArr\">" + _vm._s(_vm.v) + "</h1>\n    <button @click=\"addContent\"> add coontent </button>\n  </v-scrollbar>\n\n")])]), _vm._v(" "), _c('h3', [_vm._v("测试：用于增加内容的方法")]), _vm._v(" "), _vm._m(5), _vm._v(" "), _c('v-scrollbar', {
    ref: "vScrollbar6",
    staticClass: "vScrollbar6"
  }, [_vm._l((_vm.testArr), function(v) {
    return _c('h1', [_vm._v(_vm._s(v))])
  }), _c('button', {
    on: {
      "click": _vm.addContent
    }
  }, [_vm._v(" add coontent")])], 2), _c('div', {
    staticStyle: {
      "height": "200px"
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('pre', [_c('code', {
    staticClass: "highlight-html"
  }, [_vm._v("\n  <v-scrollbar class=\"vScrollbar1\">\n    <h1 v-for=\"n in 30\">default</h1>\n  </v-scrollbar>\n\n")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('pre', [_c('code', {
    staticClass: "highlight-html"
  }, [_vm._v("\n  <v-scrollbar class=\"vScrollbar2\" :isHideBar=\"true\">\n    <h3 v-for=\"n in 30\">:isHideBar=\"true\"</h3>\n  </v-scrollbar>\n\n")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('pre', [_c('code', [_vm._v("  <v-scrollbar class=\"vScrollbar3\" :isTopBar=\"true\">\n    <h3 v-for=\"n in 30\">:isTopBar=\"true\"</h3>\n  </v-scrollbar>\n\n")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('pre', [_c('code', [_vm._v("\n<v-scrollbar\n  class=\"vScrollbar4\"\n  :barContainerStyle=\"{width:'14px', background:'#282828' ,borderLeft:'1px solid #1d1d1d',borderRight:'1px solid #3e3e3b'}\"\n  :barStyle=\"{width:'8px',border:'1px solid #191919',borderRadius:'5px',overflow:'hidden'}\">\n\n  <div slot=\"barIn\" :style=\"{width:'100%',height:'100%',background:'#454545',borderLeft:'1px solid #585858'}\"></div>\n\n  <h3 v-for=\"n in 30\">:isTopBar=\"true\"</h3>\n</v-scrollbar>\n\n")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('pre', [_c('code', [_vm._v("  <v-scrollbar class=\"vScrollbar5\" :isTopBar=\"true\">\n    <h3 v-for=\"n in 30\">:isTopBar=\"true\"</h3>\n    <div slot=\"topBarIn\" :style=\"{position:'absolute',right:'0',top:'-5px',color:'#17ce28',zIndex:'1000'}\">♪</div>\n  </v-scrollbar>\n\n")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('pre', [_c('code', {
    staticClass: "highlight-js"
  }, [_vm._v("  data() {\n    return {\n      testArr: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10]\n    }\n  },\n\n  methods: {\n    addContent() {\n      var ii = this.testArr.length + 1\n      var len = this.testArr.length + 11\n      for (var i = ii; i < len; i++) {\n        this.testArr.push(i)\n      }\n      this.$nextTick(() => {\n        this.$refs.vScrollbar6.reCalcu() // 通过ref属性访问组件的方法reCalcu\n      })\n    }\n  }\n")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-58322f34"}!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 11
// module chunks = 0